/* eslint-disable react-hooks/exhaustive-deps */
// import {SheetDataContext} from '../../../context'
import { useContext } from 'react'
import Search from '../../../../../components/Search'
import { HideVariantPagesContext } from '../../contexts'

const HideVariantSearchComponent = ({hide_variant_details}: any) => {
  const {onSearch} = useContext(HideVariantPagesContext)

  return (
    <>
      <Search
        onSearch={(searchTerm: string) => {
          onSearch && onSearch(searchTerm)
        }}
      />
    </>
  )
}

export {HideVariantSearchComponent}
